/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "inné",
      "-2": "arú inné",
      "0": "inniu",
      "1": "amárach",
      "2": "arú amárach",
      "future": {
        "few": "i gceann {0} lá",
        "many": "i gceann {0} lá",
        "one": "i gceann {0} lá",
        "other": "i gceann {0} lá",
        "two": "i gceann {0} lá"
      },
      "past": {
        "few": "{0} lá ó shin",
        "many": "{0} lá ó shin",
        "one": "{0} lá ó shin",
        "other": "{0} lá ó shin",
        "two": "{0} lá ó shin"
      }
    },
    "day-narrow": {
      "-1": "inné",
      "-2": "arú inné",
      "0": "inniu",
      "1": "amárach",
      "2": "arú amárach",
      "future": {
        "few": "+{0} lá",
        "many": "+{0} lá",
        "one": "+{0} lá",
        "other": "+{0} lá",
        "two": "+{0} lá"
      },
      "past": {
        "few": "-{0} lá",
        "many": "-{0} lá",
        "one": "-{0} lá",
        "other": "-{0} lá",
        "two": "-{0} lá"
      }
    },
    "day-short": {
      "-1": "inné",
      "-2": "arú inné",
      "0": "inniu",
      "1": "amárach",
      "2": "arú amárach",
      "future": {
        "few": "i gceann {0} lá",
        "many": "i gceann {0} lá",
        "one": "i gceann {0} lá",
        "other": "i gceann {0} lá",
        "two": "i gceann {0} lá"
      },
      "past": {
        "few": "{0} lá ó shin",
        "many": "{0} lá ó shin",
        "one": "{0} lá ó shin",
        "other": "{0} lá ó shin",
        "two": "{0} lá ó shin"
      }
    },
    "hour": {
      "0": "an uair seo",
      "future": {
        "few": "i gceann {0} uair an chloig",
        "many": "i gceann {0} n-uair an chloig",
        "one": "i gceann {0} uair an chloig",
        "other": "i gceann {0} uair an chloig",
        "two": "i gceann {0} uair an chloig"
      },
      "past": {
        "few": "{0} uair an chloig ó shin",
        "many": "{0} n-uair an chloig ó shin",
        "one": "{0} uair an chloig ó shin",
        "other": "{0} uair an chloig ó shin",
        "two": "{0} uair an chloig ó shin"
      }
    },
    "hour-narrow": {
      "0": "an uair seo",
      "future": {
        "few": "+{0} u",
        "many": "+{0} u",
        "one": "+{0} u",
        "other": "+{0} u",
        "two": "+{0} u"
      },
      "past": {
        "few": "-{0} u",
        "many": "-{0} u",
        "one": "-{0} u",
        "other": "-{0} u",
        "two": "-{0} u"
      }
    },
    "hour-short": {
      "0": "an uair seo",
      "future": {
        "few": "i gceann {0} huaire",
        "many": "i gceann {0} n-uaire",
        "one": "i gceann {0} uair",
        "other": "i gceann {0} uair",
        "two": "i gceann {0} uair"
      },
      "past": {
        "few": "{0} huaire ó shin",
        "many": "{0} n-uaire ó shin",
        "one": "{0} uair ó shin",
        "other": "{0} uair ó shin",
        "two": "{0} uair ó shin"
      }
    },
    "minute": {
      "0": "an nóiméad seo",
      "future": {
        "few": "i gceann {0} nóiméad",
        "many": "i gceann {0} nóiméad",
        "one": "i gceann {0} nóiméad",
        "other": "i gceann {0} nóiméad",
        "two": "i gceann {0} nóiméad"
      },
      "past": {
        "few": "{0} nóiméad ó shin",
        "many": "{0} nóiméad ó shin",
        "one": "{0} nóiméad ó shin",
        "other": "{0} nóiméad ó shin",
        "two": "{0} nóiméad ó shin"
      }
    },
    "minute-narrow": {
      "0": "an nóiméad seo",
      "future": {
        "few": "+{0} n",
        "many": "+{0} n",
        "one": "+{0} n",
        "other": "+{0} n",
        "two": "+{0} n"
      },
      "past": {
        "few": "-{0} n",
        "many": "-{0} n",
        "one": "-{0} n",
        "other": "-{0} n",
        "two": "-{0} n"
      }
    },
    "minute-short": {
      "0": "an nóiméad seo",
      "future": {
        "few": "i gceann {0} nóim.",
        "many": "i gceann {0} nóim.",
        "one": "i gceann {0} nóim.",
        "other": "i gceann {0} nóim.",
        "two": "i gceann {0} nóim."
      },
      "past": {
        "few": "{0} nóim. ó shin",
        "many": "{0} nóim. ó shin",
        "one": "{0} nóim. ó shin",
        "other": "{0} nóim. ó shin",
        "two": "{0} nóim. ó shin"
      }
    },
    "month": {
      "-1": "an mhí seo caite",
      "0": "an mhí seo",
      "1": "an mhí seo chugainn",
      "future": {
        "few": "i gceann {0} mhí",
        "many": "i gceann {0} mí",
        "one": "i gceann {0} mhí",
        "other": "i gceann {0} mí",
        "two": "i gceann {0} mhí"
      },
      "past": {
        "few": "{0} mhí ó shin",
        "many": "{0} mí ó shin",
        "one": "{0} mhí ó shin",
        "other": "{0} mí ó shin",
        "two": "{0} mhí ó shin"
      }
    },
    "month-narrow": {
      "-1": "an mhí seo caite",
      "0": "an mhí seo",
      "1": "an mhí seo chugainn",
      "future": {
        "few": "+{0} mhí",
        "many": "+{0} mí",
        "one": "+{0} mhí",
        "other": "+{0} mí",
        "two": "+{0} mhí"
      },
      "past": {
        "few": "-{0} mhí",
        "many": "-{0} mí",
        "one": "-{0} mhí",
        "other": "-{0} mí",
        "two": "-{0} mhí"
      }
    },
    "month-short": {
      "-1": "an mhí seo caite",
      "0": "an mhí seo",
      "1": "an mhí seo chugainn",
      "future": {
        "few": "i gceann {0} mhí",
        "many": "i gceann {0} mí",
        "one": "i gceann {0} míosa",
        "other": "i gceann {0} mí",
        "two": "i gceann {0} mhí"
      },
      "past": {
        "few": "{0} mhí ó shin",
        "many": "{0} mí ó shin",
        "one": "{0} mhí ó shin",
        "other": "{0} mí ó shin",
        "two": "{0} mhí ó shin"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "an ráithe seo caite",
      "0": "an ráithe seo",
      "1": "an ráithe seo chugainn",
      "future": {
        "few": "i gceann {0} ráithe",
        "many": "i gceann {0} ráithe",
        "one": "i gceann {0} ráithe",
        "other": "i gceann {0} ráithe",
        "two": "i gceann {0} ráithe"
      },
      "past": {
        "few": "{0} ráithe ó shin",
        "many": "{0} ráithe ó shin",
        "one": "{0} ráithe ó shin",
        "other": "{0} ráithe ó shin",
        "two": "{0} ráithe ó shin"
      }
    },
    "quarter-narrow": {
      "-1": "an ráithe seo caite",
      "0": "an ráithe seo",
      "1": "an ráithe seo chugainn",
      "future": {
        "few": "+{0} R",
        "many": "+{0} R",
        "one": "+{0} R",
        "other": "+{0} R",
        "two": "+{0} R"
      },
      "past": {
        "few": "-{0} R",
        "many": "-{0} R",
        "one": "-{0} R",
        "other": "-{0} R",
        "two": "-{0} R"
      }
    },
    "quarter-short": {
      "-1": "an ráithe seo caite",
      "0": "an ráithe seo",
      "1": "an ráithe seo chugainn",
      "future": {
        "few": "i gceann {0} ráithe",
        "many": "i gceann {0} ráithe",
        "one": "i gceann {0} ráithe",
        "other": "i gceann {0} ráithe",
        "two": "i gceann {0} ráithe"
      },
      "past": {
        "few": "{0} ráithe ó shin",
        "many": "{0} ráithe ó shin",
        "one": "{0} ráithe ó shin",
        "other": "{0} ráithe ó shin",
        "two": "{0} ráithe ó shin"
      }
    },
    "second": {
      "0": "anois",
      "future": {
        "few": "i gceann {0} shoicind",
        "many": "i gceann {0} soicind",
        "one": "i gceann {0} soicind",
        "other": "i gceann {0} soicind",
        "two": "i gceann {0} shoicind"
      },
      "past": {
        "few": "{0} shoicind ó shin",
        "many": "{0} soicind ó shin",
        "one": "{0} soicind ó shin",
        "other": "{0} soicind ó shin",
        "two": "{0} shoicind ó shin"
      }
    },
    "second-narrow": {
      "0": "anois",
      "future": {
        "few": "+{0} s",
        "many": "+{0} s",
        "one": "+{0} s",
        "other": "+{0} s",
        "two": "+{0} s"
      },
      "past": {
        "few": "-{0} s",
        "many": "-{0} s",
        "one": "-{0} s",
        "other": "-{0} s",
        "two": "-{0} s"
      }
    },
    "second-short": {
      "0": "anois",
      "future": {
        "few": "i gceann {0} shoic.",
        "many": "i gceann {0} soic.",
        "one": "i gceann {0} soic.",
        "other": "i gceann {0} soic.",
        "two": "i gceann {0} shoic."
      },
      "past": {
        "few": "{0} shoic. ó shin",
        "many": "{0} soic. ó shin",
        "one": "{0} soic. ó shin",
        "other": "{0} soic. ó shin",
        "two": "{0} shoic. ó shin"
      }
    },
    "week": {
      "-1": "an tseachtain seo caite",
      "0": "an tseachtain seo",
      "1": "an tseachtain seo chugainn",
      "future": {
        "few": "i gceann {0} seachtaine",
        "many": "i gceann {0} seachtaine",
        "one": "i gceann {0} seachtaine",
        "other": "i gceann {0} seachtain",
        "two": "i gceann {0} sheachtain"
      },
      "past": {
        "few": "{0} seachtaine ó shin",
        "many": "{0} seachtaine ó shin",
        "one": "{0} seachtain ó shin",
        "other": "{0} seachtain ó shin",
        "two": "{0} sheachtain ó shin"
      }
    },
    "week-narrow": {
      "-1": "an tscht. seo caite",
      "0": "an tscht. seo",
      "1": "an tscht. seo chugainn",
      "future": {
        "few": "i gceann {0} shcht.",
        "many": "+{0} scht.",
        "one": "+{0} scht.",
        "other": "+{0} scht.",
        "two": "i gceann {0} shcht."
      },
      "past": {
        "few": "{0} shcht. ó shin",
        "many": "-{0} scht.",
        "one": "-{0} scht.",
        "other": "-{0} scht.",
        "two": "{0} shcht. ó shin"
      }
    },
    "week-short": {
      "-1": "an tscht. seo caite",
      "0": "an tscht. seo",
      "1": "an tscht. seo chugainn",
      "future": {
        "few": "i gceann {0} shcht.",
        "many": "i gceann {0} scht.",
        "one": "i gceann {0} scht.",
        "other": "i gceann {0} scht.",
        "two": "i gceann {0} shcht."
      },
      "past": {
        "few": "{0} shcht. ó shin",
        "many": "{0} scht. ó shin",
        "one": "{0} scht. ó shin",
        "other": "{0} scht. ó shin",
        "two": "{0} shcht. ó shin"
      }
    },
    "year": {
      "-1": "anuraidh",
      "0": "i mbliana",
      "1": "an bhliain seo chugainn",
      "future": {
        "few": "i gceann {0} bliana",
        "many": "i gceann {0} mbliana",
        "one": "i gceann {0} bliana",
        "other": "i gceann {0} bliain",
        "two": "i gceann {0} bhliain"
      },
      "past": {
        "few": "{0} bliana ó shin",
        "many": "{0} mbliana ó shin",
        "one": "{0} bhliain ó shin",
        "other": "{0} bliain ó shin",
        "two": "{0} bhliain ó shin"
      }
    },
    "year-narrow": {
      "-1": "anuraidh",
      "0": "i mbl.",
      "1": "an bhl. seo chugainn",
      "future": {
        "few": "+{0} bl.",
        "many": "+{0} mbl.",
        "one": "+{0} bhl.",
        "other": "+{0} bl.",
        "two": "+{0} bhl."
      },
      "past": {
        "few": "-{0} bl.",
        "many": "-{0} mbl.",
        "one": "-{0} bhl.",
        "other": "-{0} bl.",
        "two": "-{0} bhl."
      }
    },
    "year-short": {
      "-1": "anuraidh",
      "0": "i mbl.",
      "1": "an bhl. seo chugainn",
      "future": {
        "few": "i gceann {0} bl.",
        "many": "i gceann {0} mbl.",
        "one": "i gceann {0} bl.",
        "other": "i gceann {0} bl.",
        "two": "i gceann {0} bhl."
      },
      "past": {
        "few": "{0} bl. ó shin",
        "many": "{0} mbl. ó shin",
        "one": "{0} bhl. ó shin",
        "other": "{0} bl. ó shin",
        "two": "{0} bhl. ó shin"
      }
    }
  },
  "locale": "ga"
})
}
